/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header';
import Footer from './sub_components/main/footer';
import * as affiliateService from '../services/affiliateService';
import { CSVLink } from 'react-csv';
import printJS from 'print-js';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { BASE_IMAGE_PATH_NEW } from '../configs/api';
let linkClickTimeout
let printClickTimeout

class AffiliateClientReport extends Component {
  csvLink = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      uid: "",
      passcode: "",
      user_id: "",
      user_list: [],
      user_list_search: [],
      rg_user_list: {},
      pageLimit: 50,
      pageActive: 1,
      openPopup: "",
      selectedUser: "",
      currUserData: {},
      action: "",
      emptyClientList: false,
      shortFild: "username",
      shortType: "asc",
      searchText: "",
      showData: false,
      userDownlineList: [],
      userDownlineData: {},
      rgUserDownlineData: {},
      downline_user_id: "",
      select_downline_user_id: "",
      pdf_json: [],
      csv_json: [],
      isOfficeChannel: false,
      isOperator: false,
      allData: false,
      isOnlyClients: false,
      showClientParentSharing: false,
      selectedClientParentSharingUsr: "",
      affiliateClientReportList: [],
      affiliateClientReportListBKP: [],
      from: "",
      to: "",
      loader: false,
      totalDeposit: 0,
      totalWithdraw: 0,
      totalUserPnl: 0,
      totalCommissionMe: 0,
      totalPnl: 0,
    };
  }

  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value })
  }

  componentDidMount() {
    // this.getAffiliateClientLst();
    let userData = localStorage.getItem("tokenData")
    userData = JSON.parse(userData)
    if (!!userData) { //&& !!userData.user_role && userData.user_role === "Admin"
      let curDate = new Date().setHours(0, 0, 0, 0);
      let weekDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ to: curDate, from: weekDate })
    } else {
      this.props.history.push('/dashboard');
    }
  }

  async componentDidMountTask() {
    const { match: { params } } = this.props;
    let tokenData = localStorage.getItem("tokenData")
    tokenData = JSON.parse(tokenData)
    let currUserData = localStorage.getItem("userAccData")
    currUserData = JSON.parse(currUserData)
    this.setState({ currUserData: currUserData, isOfficeChannel: (currUserData.username === 'office' || currUserData.parents.includes('office')), isOperator: currUserData.username === 'operator' })

  }

  shortUser(fild, shortType, pageChange) {
    let userList = this.state.affiliateClientReportList
    
    if (!!userList) {
      userList.sort((a, b) => (a[fild] > b[fild]) ? 1 : ((b[fild] > a[fild]) ? -1 : 0))
      if (shortType === "dasc") {
        userList = userList.reverse()
      }
      userList.sort(function (a, b) { return b.isActive - a.isActive });
    }
    
    this.setState({ affiliateClientReportList: [] }, () => {
      this.setState({ pageActive: !!pageChange ? 1 : this.state.pageActive, affiliateClientReportList: userList, shortFild: fild, shortType: shortType })
    })
  }

  clean(obj) {
    for (var propName in obj) {
      if (obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj
  }

  async onPDFDownload(user_list_data, allData = false) {
    let pdf_json = []
    pdf_json = user_list_data
    this.setState({ pdf_json: [] }, () => {
      this.setState({ pdf_json: pdf_json, allData: allData }, () => {
        printClickTimeout = setTimeout(function () {
          printJS({
            printable: 'printJS-div',
            type: 'html',
            style: '@page { size: A4 landscape;}',
            targetStyles: ['*']
          })
        }, 500)
      })
    })
  }

  async onDownload(user_list_data, alldata = false) {
    const self = this;

    this.setState({ csv_json: [] }, () => {
      let items = []

      let i = 0

      for (let x of user_list_data) {
        if (alldata ? true : (i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)))) {
          let dictinory = {}

          dictinory["User Name"] = x["username"]
          dictinory["Affiliate Code"] = x["reference_name"]
          dictinory["Total Deposit Amount"] = x["total_deposit"]
          dictinory["Total Withdraw Amount"] = x["total_withdraw"]
          dictinory["User PNL"] = x["user_pnl"]
         //  dictinory["Commission"] = x["commission_Me"]
         //  dictinory["PNL"] = x["pnl"]
          items.push(dictinory)
        }
        i += 1
      }

      this.setState({ csv_json: items }, () => {
        linkClickTimeout = setTimeout(function () {
          self.csvLink.current.link.click();
        }, 500)
      })
    })
  }

  onSearch(e) {
    this.setState({ searchText: e.target.value }, () => {
      this.filterlist(this.state.affiliateClientReportListBKP);
    })
  }

  onAction(e) {
    const name = e.target.name;
    if (name === "first") {
      this.setState({ pageActive: 1 })
    } else if (name === "prev") {
      this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive - 1) }))
    } else if (name === "next") {
      this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive + 1) }))
    } else if (name === "last") {
      this.setState({ action: name }, this.setState({ pageActive: Math.ceil(this.state.user_list.length / this.state.pageLimit) }))
    }
  }

  onDateTimeChange(name, e) {
    this.setState({ [name]: e._d })
  }

  resetForm() {
    let curDate = new Date().setHours(0, 0, 0, 0);
    let weekDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
    this.setState({ from: weekDate, to: curDate, showData: false })
  }

  onSubmit(e) {
    let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 31) {
      this.props.notify("Date range must be 1 month.", "error");
    }
    else {
      this.setState({ action: "", page_no: 1, accounts: this.state.client_id, opening_balance: 0, first_id: "" }, () => { this.submitForm(); });
    }
  }

  parseFilterBody() {
    let body = {
      "from": new Date(this.state.from).toISOString(),
      "to": new Date(this.state.to).toISOString()
    }
    body = this.clean(body);
    return body
  }

  async submitForm() {
    const self = this;

    let body = this.parseFilterBody()
    // if(!!this.props.match.params.userId){
    //    body['userId'] = this.props.match.params.userId;
    // }
    this.setState({ loader: true, showData: false })
    affiliateService.getAffiliateClientReport(body).then((result) => {
      if (!!result) {
        if (!!result.isSuccess) {
          self.filterlist(result.data);
          self.setState({ affiliateClientReportListBKP: result.data })
        } else {
          self.setState({ affiliateClientReportListBKP: [], affiliateClientReportList: [], showData: true, loader: false, totalTotalUserCount: 0, totalTotalDeposit: 0, totalTotalwithdraw: 0, totalTotalDepositCount: 0, totalTotalwithdrawCount: 0, totalTotalRegUsrDepositCount: 0, });
          self.props.notify(result?.exception?.message, "error")
        }
      }
    })
  }

  filterlist(arr) {
    let ttlTotalDeposit = 0;
    let ttlTotalwithdraw = 0;
    let ttlUserPnl = 0;
    let ttlCommissionMe = 0;
    let ttlTotalPnl = 0;
    
    let arrlt = [];
    const search = this.state.searchText.toString().toLowerCase().trim(); 
    for (const itm of arr) {
      if (itm.username.toLowerCase().includes(search) || itm.reference_name.toLowerCase().includes(search)) {
        arrlt.push(itm);
        ttlTotalDeposit = ttlTotalDeposit + itm.total_deposit;
        ttlTotalwithdraw = ttlTotalwithdraw + itm.total_withdraw;
        ttlUserPnl = ttlUserPnl + itm.user_pnl;
      //   ttlCommissionMe = ttlCommissionMe + itm.commission_Me;
      //   ttlTotalPnl = ttlTotalPnl + itm.pnl;
      }
    }

    this.setState({
      affiliateClientReportList: arrlt,
      showData: true,
      loader: false,
      totalDeposit: ttlTotalDeposit,
      totalWithdraw: ttlTotalwithdraw,
      totalUserPnl: ttlUserPnl,
      // totalCommissionMe: ttlCommissionMe,
      // totalPnl: ttlTotalPnl,
    });
  }

  getFilteredData() {
     let rtnvl = [...this.state.affiliateClientReportList];
     const search = this.state.searchText.toString().toLowerCase().trim(); 
      if(!!search){
         rtnvl = rtnvl.filter((itm)=> itm.username.toLowerCase().includes(search) || itm.reference_name.includes(search))
      }
      return rtnvl;
  }
   

  formatNumber = (num) => {
    if (num === null || num === undefined) return '';

    return Number.isInteger(num)
      ? num.toString()
      : num.toFixed(2);
  };

  render() {
    let lst = []
    let affiliateClientRprtLst = this.getFilteredData();
    let total_page = Math.ceil(affiliateClientRprtLst.length / this.state.pageLimit)
    for (let x = 1; x <= total_page; x++) {
      if (this.state.pageActive === x || Math.abs(x - this.state.pageActive) <= 2 || (this.state.pageActive < 3 && x < 6) || (total_page - this.state.pageActive < 3 && total_page - x < 5)) {
        let htm = <button className={this.state.pageActive === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} key={"unsettle_btn_" + (x)} name="page_no" value={x} onClick={(e) => { { this.onAction(e) } this.setState({ pageActive: x }) }}>{x} </button>
        lst.push(htm)
      }
    }
    return (
      <div className="bethubs">
                  <Header history={this.props.history} />
                  <div className="wrapper">
                     <div className="container-fluid container-padding-0">
                        <div className="row">
                           <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <div className="main-box">
                                 <div>
                                    <h5 className="text-blue  mb-2">
                                       <span>Client Report</span>
                                       <div className="row user-header">
                                          <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                             <div className="form-group font-12">
                                                <Datetime
                                                   value={this.state.from}
                                                   onChange={(e) => this.onDateTimeChange("from", e)}
                                                   id="from_datetime"
                                                   dateFormat={"DD/MM/YYYY"}
                                                   timeFormat={"HH:mm"}
                                                />
                                             </div>
                                          </div>
                                          <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                             <div className="form-group font-12">
                                                <Datetime
                                                   value={this.state.to}
                                                   onChange={(e) => this.onDateTimeChange("to", e)}
                                                   id="to_datetime"
                                                   dateFormat={"DD/MM/YYYY"}
                                                   timeFormat={"HH:mm"}
                                                />
                                             </div>
                                          </div>
                                          <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                             <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                                <button className="btn btn-blue" disabled={!!this.state.from && !!this.state.to ? false : true} onClick={(e) => this.onSubmit(e)}>Go</button>
                                                <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                             </div>
                                          </div>
                                          
                                          <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
      
                                          </div>
                                          </div>
                                          <div className="row user-header">
                                          <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                             
                                             {/* <div className="form-group mb-0 d-inline">
                                                <input className="form-control  d-inline-block" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" value={this.state.searchText} />
                                             </div> */}
                                             <div className="d-flex float-left">
                                                <div className="form-group mb-0 d-inline">
                                                   <input className="form-control  d-inline-block" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" value={this.state.searchText} />
                                                </div>
                                                <CSVLink
                                                   data={this.state.csv_json}
                                                   filename={"Affiliate Report.csv"}
                                                   asyncOnClick={true}
                                                   className="d-none"
                                                   ref={this.csvLink}>
                                                </CSVLink>
                                                <button className="btn btn-sm d-inline csv-icon p-0 pl-1" title="Export Data" onClick={(e) => this.onDownload(this.state.affiliateClientReportList, true)} disabled={this.state.affiliateClientReportList.length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon.svg`}></img></button>
                                                <div style={{ display: "none" }}>
                                                   <div id="printJS-div">
      
                                                      <table id="exportall" className="table font-12 table-bordered table-sm w-100" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px', width: '100%' }} >
                                                         <thead>
                                                            <tr>
                                                               <th>User Name</th>
                                                               <th>Affiliate Code</th>
                                                               <th>Total Deposit Amount</th>
                                                               <th>Total Withdraw Amount</th>
                                                               <th>User PNL</th>
                                                               {/* <th>Commission Me</th>
                                                               <th>PNL</th> */}
                                                            </tr>
                                                         </thead>
                                                         <tbody>
                                                            {this.state.pdf_json.length > 1 && this.state.pdf_json.map((usr, i) => {
                                                               return (<>
                                                                  {/* {(this.state.allData ? true : i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1))) &&  */}
                                                                     <tr>
                                                                        <td>{usr.username}</td>
                                                                        <td>{usr.reference_name}</td>
                                                                        <td className='text-right'><span>{this.formatNumber(usr.total_deposit)}</span></td>
                                                                        <td className='text-right'><span>{this.formatNumber(usr.total_withdraw)}</span></td>
                                                                        <td className='text-right'><span>{this.formatNumber(usr.user_pnl)}</span></td>
                                                                        {/* <td className='text-right'><span>{this.formatNumber(usr.commission_Me)}</span></td>
                                                                        <td className='text-right'><span>{this.formatNumber(usr.pnl)}</span></td> */}
                                                                     </tr>
                                                            {/* } */}
                                                               </>
                                                               )
                                                            })
                                                            }
                                                         </tbody>
                                                      </table>
                                                   </div>
                                                </div>
                                                <button className="btn btn-sm pdf-icon d-inline p-0" title="Export Data" onClick={(e) => this.onPDFDownload(this.state.affiliateClientReportList, true)} disabled={this.state.affiliateClientReportList.length > 0 ? false : true}>
                                                   <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon.svg`}></img>
                                                </button>
                                                {/* <button className="btn btn-sm d-inline csv-icon-all p-0 mx-2" title="Export All Data" onClick={(e) => this.onDownload(userList, true)} disabled={this.state.user_list.length > 0 ? false : true}>
                                                   <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon-all.svg`}></img>
                                                </button>
                                                <button className="btn btn-sm pdf-icon-all d-inline p-0" title="Export All Data" onClick={(e) => this.onPDFDownload(userList, true)} disabled={this.state.user_list.length > 0 ? false : true}>
                                                   <img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/pdf-icon-all.svg`}></img>
                                                </button> */}
                                             </div>
                                          </div>
                                       </div>
                                    </h5>
                                 </div>
      
                                 <div className="row mt-1">
                                    
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 table-responsive">
                                       {this.state.loader ?
                                          <span>Loading...</span>
                                          :
                                          (!!affiliateClientRprtLst && affiliateClientRprtLst.length > 0 ?
                                             <>
                                                <table id="example" className="table table-striped table-bordered table-sm addpadding nowrap" style={{ width: "100%" }}>
                                                   <thead>
                                                      <tr>
                                                         <th>Sr.</th>
                                                         <th>
                                                            <span>User Name</span>
                                                            <span className="d-contant" style={{ float: "right" }}>
                                                               <span onClick={() => { this.shortUser("username", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                               <span onClick={() => { this.shortUser("username", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                            </span>
                                                         </th>
                                                         <th>Affiliate Code
                                                            <span className="d-contant" style={{ float: "right" }}>
                                                               <span onClick={() => { this.shortUser("reference_name", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                               <span onClick={() => { this.shortUser("reference_name", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                            </span>
                                                         </th>
                                                         <th>Total Deposit Amount
                                                            <span className="d-contant" style={{ float: "right" }}>
                                                               <span onClick={() => { this.shortUser("total_deposit", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                               <span onClick={() => { this.shortUser("total_deposit", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                            </span>
                                                         </th>
                                                         <th>Total Withdraw Amount
                                                            <span className="d-contant" style={{ float: "right" }}>
                                                               <span onClick={() => { this.shortUser("total_withdraw", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                               <span onClick={() => { this.shortUser("total_withdraw", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                            </span>
                                                         </th>
                                                         <th>User PNL
                                                            <span className="d-contant" style={{ float: "right" }}>
                                                               <span onClick={() => { this.shortUser("user_pnl", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                               <span onClick={() => { this.shortUser("user_pnl", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                            </span>
                                                         </th>
                                                         {/* <th>Commission Me
                                                            <span className="d-contant" style={{ float: "right" }}>
                                                               <span onClick={() => { this.shortUser("commission_Me", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                               <span onClick={() => { this.shortUser("commission_Me", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                            </span>
                                                         </th>
                                                         <th>PNL
                                                            <span className="d-contant" style={{ float: "right" }}>
                                                               <span onClick={() => { this.shortUser("pnl", "asc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                               <span onClick={() => { this.shortUser("pnl", "dasc", true) }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                                            </span>
                                                         </th> */}
      
                                                      </tr>
                                                   </thead>
                                                   <tbody>
                                                      {affiliateClientRprtLst.map((usr, i) => {
                                                         if (this.state.allData ? "" : i >= (this.state.pageLimit * this.state.pageActive) || (i + 1) <= (this.state.pageLimit * (this.state.pageActive - 1))) {
                                                            return false
                                                         }
                                                         return (
                                                            <>
                                                               {/* {i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) && */}
      
                                                               <tr key={i+1}>
                                                                  <td>{i+1}</td>
                                                                  <td>{usr.username}</td>
                                                                  <td>{usr.reference_name}</td>
                                                                  <td className='text-right'><span>{this.formatNumber(usr.total_deposit)}</span></td>
                                                                  <td className='text-right'><span>{this.formatNumber(usr.total_withdraw)}</span></td>
                                                                  <td className='text-right'><span>{this.formatNumber(usr.user_pnl)}</span></td>
                                                                  {/* <td className='text-right'><span>{this.formatNumber(usr.commission_Me)}</span></td>
                                                                  <td className='text-right'><span>{this.formatNumber(usr.pnl)}</span></td> */}
                                                               </tr>
                                                               {/* } */}
                                                            </>
                                                         )
                                                      })}
                                                      <tr>
                                                         <td className='font-weight-bold' colSpan={3}><span>Total</span></td>
                                                         <td className='text-right font-weight-bold'><span>{this.formatNumber(this.state.totalDeposit)}</span></td>
                                                         <td className='text-right font-weight-bold'><span>{this.formatNumber(this.state.totalWithdraw)}</span></td>
                                                         <td className='text-right font-weight-bold'><span>{this.formatNumber(this.state.totalUserPnl)}</span></td>
                                                         {/* <td className='text-right font-weight-bold'><span>{this.formatNumber(this.state.totalCommissionMe)}</span></td>
                                                         <td className='text-right font-weight-bold'><span>{this.formatNumber(this.state.totalPnl)}</span></td> */}
                                                      </tr>
                                                   </tbody>
                                                </table> 
                                             </>
                                             :
                                             <span> No Record Found.</span>
                                          )
                                       }
                                    </div>
                                 </div>
      
                                 {
                                    affiliateClientRprtLst.length > 0 &&
                                    <>
                                       <div className="row">
                                          <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {(this.state.pageLimit * (this.state.pageActive - 1)) + 1} to {(this.state.pageLimit * this.state.pageActive) < affiliateClientRprtLst.length ? (this.state.pageLimit * this.state.pageActive) : affiliateClientRprtLst.length} of {affiliateClientRprtLst.length} entries</span></div>
                                          <div className="col-12 col-sm-12 col-md-6">
                                             <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                                <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>First</button>
                                                <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>Prev</button>
                                                {lst}
                                                <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil(affiliateClientRprtLst.length / this.state.pageLimit) ? true : false}>Next</button>
                                                <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil(affiliateClientRprtLst.length / this.state.pageLimit) ? true : false}>Last</button>
                                             </div>
                                          </div>
                                       </div>
                                    </>
                                 }
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <Footer />
               </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}
function mapDispatchToProps(dispatch) {
  return {
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AffiliateClientReport);
